import apiClient from '@/services/rest-api-sms/apiClient'
import * as fuelTypeApi from '@/services/rest-api-sms/lib/fuel-type/fuel-type'
import * as vehicleModelApi from '@/services/rest-api-sms/lib/vehicle/vehicle-model'

const baseEndpoint = '/vehicle-type'

export const get = async (queryParam) => {
  queryParam.filters = [`company_id eq 1`]
  const params = {
    page: queryParam?.page || undefined,
    limit: queryParam?.limit || undefined,
    sorts: queryParam?.sorts?.length > 0 ? queryParam.sorts : undefined,
    search: queryParam?.search || undefined,
    filters: queryParam?.filters || undefined,
  }
  const response = await apiClient({
    method: 'GET',
    url: `${baseEndpoint}`,
    params: params,
  })

  response.data.data.paginated_result?.forEach((val) => {
    val['can_edit'] = true
    val['can_delete'] = true
  })

  await mapVehicleTypes()
  response.data.data.paginated_result.map(async (vehicleType) => {
    vehicleType.fuel_type = await constants.data.fuelTypes.find((fuelType) => {
      fuelType.fuel_type_id === vehicleType.fuel_type_id
    })
    vehicleType.transmission_type = constants.data.transmissionTypeOptions.find(
      (transmissionType) => transmissionType.transmission_key === vehicleType.transmission_type
    ).transmission_type
  })

  return response?.data
}

export const getTJ = async (queryParam) => {
  const params = {
    page: queryParam?.page || undefined,
    limit: queryParam?.limit || undefined,
    sorts: queryParam?.sorts?.length > 0 ? queryParam.sorts : undefined,
    search: queryParam?.search || undefined,
    filters: queryParam?.filters || undefined,
  }
  const response = await apiClient({
    method: 'GET',
    url: `${baseEndpoint}`,
    params: params,
  })

  response.data.data.paginated_result?.forEach((val) => {
    val['can_edit'] = true
    val['can_delete'] = true
  })

  await mapVehicleTypes()
  response.data.data.paginated_result.map(async (vehicleType) => {
    vehicleType.fuel_type = await constants.data.fuelTypes.find((fuelType) => {
      fuelType.fuel_type_id === vehicleType.fuel_type_id
    })
    vehicleType.transmission_type = constants.data.transmissionTypeOptions.find(
      (transmissionType) => transmissionType.transmission_key === vehicleType.transmission_type
    ).transmission_type
  })

  return response?.data
}

export const constants = {
  data: {
    fuelTypes: [],
    transmissionTypeOptions: [],
    vehicleModels: [],
  },
}

export const mapVehicleTypes = async () => {
  /** define transmissionType*/
  constants.data.transmissionTypeOptions = [
    { transmission_key: 'A', transmission_type: 'Otomatis' },
    { transmission_key: 'M', transmission_type: 'Manual' },
  ]

  /** define fuelTypes*/
  let params = {
    page: 1,
    limit: 1,
  }
  let fuelTypes = await fuelTypeApi.get(params)
  params.limit = fuelTypes.metadata.total_count
  fuelTypes = await fuelTypeApi.get(params)

  constants.data.fuelTypes = fuelTypes.data.paginated_result
}

export const show = async (id) => {
  const response = await apiClient({
    method: 'GET',
    url: `${baseEndpoint}/${id}`,
  })
  let result = response?.data
  result['can_edit'] = true
  result['can_delete'] = true

  let params = {
    search: result.model,
  }
  const vehicleModels = await vehicleModelApi.get(params)
  const vehicleModel = `${result.manufacturer} - ${result.model}`

  const foundVehicleModel = vehicleModels.data?.paginated_result?.find(
    (data) => `${data.manufacturer} - ${data.model}` === vehicleModel
  )
  result.manufacturer = foundVehicleModel
    ? `${foundVehicleModel.manufacturer} - ${foundVehicleModel.model}`
    : null

  const fuelType = result.fuel_type_id ? await fuelTypeApi.show(result.fuel_type_id) : null

  result.fuel_type = fuelType?.name || null
  result.transmission_type = constants.data.transmissionTypeOptions?.find(
    (e) => e.transmission_key === result.transmission_type
  ).transmission_type

  return result
}

export const deleteMany = async (data) => {
  const response = await apiClient({
    method: 'DELETE',
    url: `${baseEndpoint}`,
    data,
  })
  return response
}

export const store = async (data) => {
  if (!data) return
  const fuelType = constants.data.fuelTypes.find((e) => e.name === data.fuel_type_name)
  const transmissionType = constants.data.transmissionTypeOptions.find(
    (e) => e.transmission_type === data.transmission_type
  ).transmission_key

  // Manipulasi data
  // 1. Handle fuel_type_name
  if (data.fuel_type_name) {
    data.fuel_type_id = fuelType.fuel_type_id
    delete data.fuel_type_name
  }
  if (data.transmission_type) {
    data.transmission_type = transmissionType
  }
  // 2. Handle manufacturer field (split "Suzuki - New Carry" menjadi manufacturer dan model)
  if (data.manufacturer && data.manufacturer.includes(' - ')) {
    const [manufacturer, model] = data.manufacturer.split(' - ')
    data.manufacturer = manufacturer
    data.model = model
  }

  if (data.icon?.value) {
    data.icon = data.icon.value
  }

  const response = await apiClient({
    method: 'POST',
    url: `${baseEndpoint}`,
    data: {
      ...data,
      company_id: 1,
      is_active: true,
    },
  })
  return response
}

export const update = async (id, data) => {
  if (!data) return
  const fuelType = constants.data.fuelTypes.find((e) => e.name === data.fuel_type_name)
  const transmissionType = constants.data.transmissionTypeOptions.find(
    (e) => e.transmission_type === data.transmission_type
  ).transmission_key

  // Manipulasi data
  // 1. Handle fuel_type_name
  if (data.fuel_type_name) {
    data.fuel_type_id = fuelType.fuel_type_id
    delete data.fuel_type_name
  }
  if (data.transmission_type) {
    data.transmission_type = transmissionType
  }
  // 2. Handle manufacturer field (split "Suzuki - New Carry" menjadi manufacturer dan model)
  if (data.manufacturer && data.manufacturer.includes(' - ')) {
    const [manufacturer, model] = data.manufacturer.split(' - ')
    data.manufacturer = manufacturer
    data.model = model
  }

  const response = await apiClient({
    method: 'PATCH',
    url: `${baseEndpoint}/${id}`,
    data,
  })
  return response
}
